import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Form, Select } from '@arco-design/web-react';
import type { FormInstance } from '@arco-design/web-react/es/Form';

import { MAAS_SELECT_PLACEHOLDER, maasRequiredRules, parseFormJsonField } from '@/delivery-type-plugin/capabilities/maas-init';
import {
  SERVICE_MOUNT_GROUP_NAME_FIELD,
  buildServiceMountNodeOptions,
  normalizeServiceList,
} from '@/delivery-type-plugin/capabilities/service';

export interface AppInstanceServiceMountFieldsProps {
  form: FormInstance;
}

/** 应用实例服务入口节点（提交时写入每条 network.service[].groupNames） */
export function AppInstanceServiceMountFields({ form }: AppInstanceServiceMountFieldsProps) {
  const { t } = useTranslation();
  const runMode = Form.useWatch('runMode', form);
  const masterNodes = Form.useWatch('masterNodes', form);
  const workerNodes = Form.useWatch('workerNodes', form);
  const inferenceServiceRaw = Form.useWatch('_inferenceService', form);

  const mountOptions = useMemo(
    () => buildServiceMountNodeOptions({ runMode, masterNodes, workerNodes }),
    [masterNodes, runMode, workerNodes],
  );

  const serviceList = useMemo(() => normalizeServiceList(parseFormJsonField(inferenceServiceRaw)), [inferenceServiceRaw]);
  const requireMountNode = mountOptions.length > 0 && serviceList.length > 0;

  return (
    <Form.Item
      field={SERVICE_MOUNT_GROUP_NAME_FIELD}
      label={t('data-center:maas.service.entry.nodes')}
      style={{ marginTop: 12 }}
      rules={requireMountNode ? maasRequiredRules(t('data-center:maas.service.entry.nodes.select')) : []}
    >
      <Select
        mode="multiple"
        placeholder={mountOptions.length ? MAAS_SELECT_PLACEHOLDER : t('data-center:maas.service.entry.nodes.configure.first')}
        options={mountOptions}
        allowClear
        disabled={!mountOptions.length}
      />
    </Form.Item>
  );
}
